 
export class UserQuelleAllgemein {
  bezeichnung: string;
  gewichtungsfaktor: number;
  xKoordinate: number;
  yKoordinate: number;
  
}
